import * as tslib_1 from "tslib";
import { TinyYolov2Options } from 'tfjs-tiny-yolov2';
var TinyFaceDetectorOptions = /** @class */ (function (_super) {
    tslib_1.__extends(TinyFaceDetectorOptions, _super);
    function TinyFaceDetectorOptions() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._name = 'TinyFaceDetectorOptions';
        return _this;
    }
    return TinyFaceDetectorOptions;
}(TinyYolov2Options));
export { TinyFaceDetectorOptions };
//# sourceMappingURL=TinyFaceDetectorOptions.js.map